import { orderFormStore } from "@infrastructure/stores/orderForm.store";
import { OrderState } from "@domain/states/order.state";

/**
 * Domain сервис для работы с формой заказа
 * Предоставляет интерфейс для boundary слоя без прямого доступа к infrastructure
 */
class OrderFormServiceClass {
  /**
   * Получает состояние заказа для указанной машины
   */
  getOrder(machineId: number): OrderState {
    return orderFormStore.getOrder(machineId);
  }

  /**
   * Удаляет состояние заказа для указанной машины
   */
  removeOrder(machineId: number): void {
    orderFormStore.removeOrder(machineId);
  }

  /**
   * Удаляет все состояния заказов
   */
  removeAll(): void {
    orderFormStore.removeAll();
  }
}

export const OrderFormService = new OrderFormServiceClass();

